import { chatStore, configStore } from 'src/store'
import { configAsync } from 'src/store/async'
import { useEffect, useLayoutEffect } from 'react'
import LoginModal from '../LoginModal'
import ConfigModal from '../ConfigModal'
import { userStore } from 'src/store'
import { postSignin } from 'src/request/api'
import { userAsync } from 'src/store/async'
import { notification, message } from 'antd'
import React from 'react'

type Props = {
  children: React.ReactElement
}

function Global(props: Props) {
  const { models, config, configModal, changeConfig, setConfigModal, notifications } = configStore()
  const { chats, addChat, changeSelectChatId } = chatStore()
  const { token, loginModal, setLoginModal, user_info } = userStore()

  const openNotification = ({
    key,
    title,
    content
  }: {
    key: string | number
    title: string
    content: string
  }) => {
    return notification.open({
      key,
      message: title,
      description: (
        <div
          dangerouslySetInnerHTML={{
            __html: content
          }}
        />
      ),
      onClick: () => {
        if (process.env.REACT_APP_DISABLE_CONSOLE === 'true') {
          console.log('Notification Clicked!')
        }
      }
    })
  }

  function delay(ms: number) {
	return new Promise(resolve => setTimeout(resolve, ms));
  }

  async function onOpenNotifications() {
    for (const item of notifications) {
      await openNotification({
        key: item.id,
        title: item.title,
        content: item.content
      })
	  await delay(500)
    }
  }

  useEffect(() => {
    if (chats.length <= 0) {
      addChat('MateBot', '')
    } else {
      const id = chats[0].id
      changeSelectChatId(id)
    }
    if (token && !user_info?.is_signin) {
      postSignin()
      .then((res) => {
        if (res.code) return
        userAsync.fetchUserInfo()
        message.success(res.message)
      })
    }
	configAsync.fetchConfig()
  }, [])

  useLayoutEffect(()=>{
	onOpenNotifications();
  },[notification])

  return (
    <>
      {props.children}
      <LoginModal
        open={loginModal}
        onCancel={() => {
          setLoginModal(false)
        }}
      />
      <ConfigModal
        open={configModal}
        onCancel={() => {
          setConfigModal(false)
        }}
        models={models}
        onChange={changeConfig}
        data={config}
      />
    </>
  )
}
export default Global
